<template>
  <div class="ibox-tools">
    <a class="dropdown-toggle" data-toggle="dropdown" href="#">
      <i class="fas fa-cloud-download-alt"></i>
    </a>
    <ul class="dropdown-menu dropdown-user">
      <li>
        <a class="dropdown-item" @click="exportExcel"
          ><i class="fa fa-file-excel"></i>excel</a
        >
      </li>
    </ul>
  </div>
</template>
<script>
import { apiCall } from "/src/api/imports";

export default {
  props: {
    excel: {
      type: String,
    },
  },
  methods: {
    async exportExcel() {
      this.$setIsLoading(true)
      // try {
      const { data } = await apiCall("get", `${this.$apiURL}/${this.excel}`, {
        responseType: "arraybuffer",
      });

      console.log(data);
      const url = URL.createObjectURL(
        new Blob([data], { type: "application/xls", encoding: "UTF-8" })
      );

      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("class", "d-none");
      link.setAttribute(
        "download",
        this.$getTimeFromNow("YYYY-MM-DD_HH-mm-ss") + "-file.xls"
      );
      document.body.appendChild(link);
      link.click();
      // } catch (e) {}

      // return `${this.$apiURL}/${this.excel}`;
      this.$setIsLoading(false)
    },
  },
};
</script>
